<template>
  <v-row align="center" class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-card flat class="ma-0 pa-0 overflow-y-auto" color="transparent" :style="contentsHeight + ' overflow-x: hidden;'">
        <template v-for="item in group">
          <v-row align="center" class="ma-0 pa-0" :key="item + 'header'">
            <v-col cols="12" class="pa-0 b-B-TITLE">
              <v-row align="baseline" class="ma-0 pa-0">
                <v-col cols="4" class="pa-0">
                  <v-card-title class="pb-0">{{ getName(item) }}</v-card-title>
                </v-col>
                <v-col v-if="year == getFY()" cols="8" class="py-0">
                  <v-row align="center" justify="end" class="ma-0 pa-0">
                    <template v-for="(kpi, index) in kpis">
                      <v-col cols="2" class="pa-0" align="center" :key="index + '_name'">
                        <v-sheet :color="pColor(item)" tile class="white--text b-L-GREY b-T-GREY b-B-GREY caption" height="21">
                          <v-tooltip bottom color="transparent">
                            <template v-slot:activator="{ on }">
                              <span v-on="on">{{ kpi.name }}</span>
                            </template>
                            <v-card class="pa-0" width="160">
                              <v-card-text class="pa-1 caption secondary--text text-center">
                                <span>{{ kpi.tips }}</span><br>
                              </v-card-text>
                            </v-card>
                          </v-tooltip>
                        </v-sheet>
                      </v-col>
                      <v-col cols="1" class="pa-0" align="right" :key="index + '_value'">
                        <v-sheet :color="getWeekColor(1)" tile class="select-none b-L-GREY b-T-GREY b-B-GREY b-R-GREY font-weight-bold mr-1" height="21">
                          <span>{{ kpidata[item][index] }}</span>
                          <span class="hidden-sm-and-down">%</span>
                          </v-sheet>
                      </v-col>
                    </template>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-card-text :key="item">
                <v-row align="center" class="ma-0 pa-0">
                  <v-col cols="2" class="pa-0">
                    <v-toolbar flat height="21" color="transparent" >
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-col>
                  <v-col cols="10" class="pa-0">
                    <v-row align="center" class="ma-0 pa-0">
                       <v-col class="pa-0" align="center" v-for="i in 13" :key="i">
                          <v-sheet
                            :color="year == getFY() && mm == i ? pColor(item) : getWeekColor(1)"
                            dark
                            height="21"
                            :key="i"
                            tile
                            :class="i == 13 ? 'b-L-GREY b-R-GREY b-T-GREY text-center' : 'b-L-GREY b-T-GREY text-center'"
                          >
                            <span :class="year == getFY() && mm == i ? 'white--text' : 'secondary--text'">{{ getMonth(i) }}</span>
                          </v-sheet>
                       </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <template v-for="(metric, index) in headers">
                  <v-row v-if="data && metric.roles[getPrivilege(data)]" align="center" class="ma-0 pa-0" :key="index">
                    <v-col cols="2" class="pa-0">
                      <v-sheet :color="getWeekColor(1)" tile :class="(headers.length - 1) == index ? 'b-L-GREY b-T-GREY b-B-GREY' : 'b-L-GREY b-T-GREY'" height="21">
                        <template v-if="metric.type != 'header' && metric.type != 'TTL'">
                          <span class="pl-4">{{ metric.name + '（' + metric.sufix + '）' }}</span>
                        </template>
                        <template v-else>
                          <v-toolbar flat :color="pColor(item)" height="20">
                            <span class="white--text">{{ metric.name + '（' + metric.sufix + '）' }}</span>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </template>
                      </v-sheet>
                      <template v-if="compare != 'N/A' && metric.type !== 'TTL'">
                        <v-sheet :color="metric.type == 'header' ? pColor(item) : 'transparent'" tile :class="(headers.length - 1) == index ? 'b-L-GREY b-B-GREY' : 'b-L-GREY'" height="21">
                        </v-sheet>
                      </template>
                    </v-col>
                    <v-col cols="10" class="pa-0">
                      <v-row align="center" class="ma-0 pa-0">
                        <v-col class="pa-0" v-for="i in 13" :key="i">
                          <v-sheet
                            :class="getBackgroundColor(mm, i, index, headers)"
                            :color="checkValue(item, i, index, metric)"
                            height="21"
                            :key="i"
                            tile
                          >
                            <template v-if="i != 13">
                              <span
                                style="text-align: right; width: 100%;"
                                :class="checkClickable(i, metric)"
                                @click.stop="onValueSelect(item, i, 0, metric)"
                              >
                                {{ getValue(item, i, index, 0, metric) }}
                              </span>
                            </template>
                            <template v-else>
                              <span
                                style="text-align: right; width: 100%;"
                                class="pr-1 font-weight-bold select-none"
                              >
                                {{ getTotalValue(item, index, metric, 0) }}
                              </span>
                            </template>
                          </v-sheet>
                        </v-col>
                      </v-row>
                      <template v-if="compare != 'N/A' && metric.type !== 'TTL'">
                        <v-row align="center" class="ma-0 pa-0">
                          <v-col class="pa-0" v-for="i in 13" :key="i">
                            <v-sheet
                              :class="getBackgroundColor(mm, i, index, headers)"
                              :color="compare == '目標' ? sColor : '#bbbbbb30'"
                              height="21"
                              :key="i"
                              tile
                            >
                              <span
                                v-if="i != 13"
                                style="text-align: right; width: 100%;"
                                class="pr-1 select-none"
                              >
                                {{ getValue(item, i, index, 1, metric) }}
                              </span>
                              <span v-else
                                style="text-align: right; width: 100%;"
                                class="pr-1 font-weight-bold select-none"
                              >
                                {{ getTotalValue(item, index, metric, 1) }}
                              </span>
                            </v-sheet>
                          </v-col>
                        </v-row>
                      </template>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-card-text class="py-0" :key="item + 'ycsheaders'">
                <v-row align="center" class="ma-0 pa-0">
                  <v-col cols="4" class="pa-0">
                  </v-col>
                  <v-col v-if="year == getFY()" cols="8" class="px-0">
                    <v-row align="center" justify="end" class="ma-0 pa-0">
                      <template v-for="(ycs, index) in ycss">
                        <v-col cols="1" class="pa-0" align="center" :key="index + '_name'">
                          <v-sheet :color="pColor(item)" tile class="white--text b-L-GREY b-T-GREY b-B-GREY caption" height="21">
                            <v-tooltip bottom color="transparent">
                              <template v-slot:activator="{ on }">
                                <span v-on="on">{{ ycs.name }}</span>
                              </template>
                              <v-card class="pa-0" width="160">
                                <v-card-text class="pa-1 caption secondary--text text-center">
                                  <span>{{ ycs.tips }}</span><br>
                                </v-card-text>
                              </v-card>
                            </v-tooltip>
                          </v-sheet>
                        </v-col>
                        <v-col cols="1" class="pa-0" align="right" :key="index + '_value'">
                          <v-sheet :color="getWeekColor(1)" tile class="select-none b-L-GREY b-T-GREY b-B-GREY b-R-GREY font-weight-bold mr-1" height="21">
                            <span>{{ ycsdata[item][index] }}</span>
                            <span class="hidden-sm-and-down">%</span>
                            </v-sheet>
                        </v-col>
                      </template>
                    </v-row>
                  </v-col>
                  <v-col v-else cols="8" class="px-0">
                  </v-col>
                  <v-col cols="2" class="pa-0">
                    <v-toolbar flat height="21" color="transparent" >
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-col>
                  <v-col cols="10" class="pa-0">
                    <v-row align="center" class="ma-0 pa-0">
                       <v-col class="pa-0" align="center" v-for="i in 13" :key="i">
                          <v-sheet
                            :color="year == getFY() && mm == i ? pColor(item) : getWeekColor(1)"
                            dark
                            height="21"
                            :key="i"
                            tile
                            :class="i == 13 ? 'b-L-GREY b-R-GREY b-T-GREY text-center' : 'b-L-GREY b-T-GREY text-center'"
                          >
                            <span :class="year == getFY() && mm == i ? 'white--text select-none' : 'secondary--text select-none'">{{ getMonth(i) }}</span>
                          </v-sheet>
                       </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <template v-for="(metric, index) in ycsheaders">
                  <v-row v-if="metric.roles[getPrivilege(data)]" align="center" class="ma-0 pa-0" :key="index + 'ycsheaders'">
                    <v-col cols="2" class="pa-0">
                      <v-sheet color="transparent" tile :class="(ycsheaders.length - 1) == index ? 'b-L-GREY b-T-GREY b-B-GREY' : 'b-L-GREY b-T-GREY'" height="21">
                        <template v-if="metric.type != 'header' && metric.type != 'TTL'">
                          <span class="pl-4">{{ metric.name + '（' + metric.sufix + '）' }}</span>
                        </template>
                        <template v-else>
                          <v-toolbar flat :color="pColor(item)" height="20">
                            <span class="white--text">{{ metric.name }}</span>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </template>
                      </v-sheet>
                    </v-col>
                    <v-col cols="10" class="pa-0">
                      <v-row align="center" class="ma-0 pa-0">
                        <v-col class="pa-0" v-for="i in 13" :key="i">
                          <v-sheet
                            :class="getBackgroundColor(mm, i, index, ycsheaders)"
                            :color="checkValue(item, i, index, metric)"
                            height="21"
                            :key="i"
                            tile
                          >
                            <template v-if="i != 13">
                              <span
                                style="text-align: right; width: 100%;"
                                :class="checkClickable(i, metric)"
                                @click.stop="onTygSelect(item, i, 0, metric)"
                              >
                                {{ getTyg(item, i, index, 0, metric) }}
                              </span>
                            </template>
                            <template v-else>
                              <span
                                style="text-align: right; width: 100%;"
                                class="pr-1 font-weight-bold select-none"
                              >
                                {{ getTotalTyg(item, index, metric) }}
                              </span>
                            </template>
                          </v-sheet>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-col>
          </v-row>
        </template>
      </v-card>
    </v-col>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

    <div>
      <v-dialog v-model="listDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-list-dialog
          v-if="listDialog"
          @dismissed="onDismissed"
          :tempGroups="tempGroups"
          :selected="selected"
          :type="type"
        >
        </app-list-dialog>
      </v-dialog>
    </div>

  </v-row>
</template>
<script>
import moment from 'moment-timezone'
import { mapGetters } from 'vuex'
export default {
  props: [ 'view', 'g', 'm', 'year', 'group', 'tempGroups', 'compare', 'indicator', 'acts', 'plans', 'status', 'diffs', 'totalTygs', 'kpis', 'ycss', 'kpidata', 'ycsdata', 'sColor' ],
  data () {
    return {
      mm: 0,
      loading: false,
      listDialog: false,
      type: 1,
      item: null,
      items: {},
      headers: [
        { key: 401, name: 'DTS', group: 'X', type: 'header', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 402, name: '生徒面談', group: 'X', type: 'header', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 403, name: '保護者面談', group: 'X', type: 'header', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 17, name: '在籍', group: 'X', type: 'TTL', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      ycsheaders: [
        { key: 1, name: '◎', group: 'X', type: 'header', sufix: '回', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 2, name: '◯', group: 'X', type: 'header', sufix: '回', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 3, name: '△', group: 'X', type: 'header', sufix: '回', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 4, name: 'Ｘ', group: 'X', type: 'header', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 17, name: '在籍（人）', group: 'X', type: 'TTL', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      privilege: 'shared/privilege',
      metricsPlans: 'metricsPlans/metrics',
      metricsActs: 'metricsActs/metrics',
      metricsStatus: 'metricsStatus/metrics',
      windowSize: 'shared/windowSize'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    }
  },
  created () {
    moment.tz.setDefault('Asia/Tokyo')
    var mm = moment().month()
    this.mm = mm > 2 ? mm - 2 : mm + 10
  },
  methods: {
    pColor (group) {
      var color = 'primary'
      if (group !== '*') {
        var index = this.groups.findIndex(g => g.key === group)
        if (index !== -1) {
          if (typeof this.groups[index].color !== 'undefined') {
            return this.groups[index].color
          }
        }
      }
      return color
    },
    getBackgroundColor (mm, i, index, headers) {
      var color = (i === 13 ? 'd-flex b-L-GREY b-R-GREY b-T-GREY' : 'd-flex b-L-GREY b-T-GREY')
      if ((headers.length - 1) === index) {
        color += ' b-B-GREY'
      }
      return color
    },
    checkValue (item, i, index, metric) {
      if (metric.type === 'header' || metric.type === 'none') {
        return this.year === this.getFY() && this.mm === i ? this.pColor(item) : this.getWeekColor(1)
      }
      if (metric.type === 'TTL') {
        return this.year === this.getFY() && this.mm === i ? this.pColor(item) : this.getWeekColor(1)
      }
      if (item === '*') {
        return 'transparent'
      }
      if (this.fn === 'plan' && this.items[item] && i !== 13 && this.items[item][i - 1][index].modify) {
        return 'pink lighten-5'
      }
      return 'transparent'
    },
    checkClickable (i, metric) {
      var c = 'pr-1'
      if ((metric.type === 'header' || metric.type === 'TTL') && this.year === this.getFY() && this.mm === i) {
        c += ' white--text'
      }
      if (metric.type !== 'TTL') {
        c += ' clickable'
      } else {
        c += ' select-none'
      }
      return c
    },
    getTotalValue (item, index, metric, type) {
      var a = 0
      var ac = 0
      var p = 0
      var pc = 0
      var d = 0
      var dc = 0
      if (!this.status[item]) {
        return 0
      }
      for (var x = 0; x < 12; x++) {
        if (typeof this.status[item][x][index + 9] !== 'undefined') {
          var v = this.status[item][x][index + 9].length
          if (index === 1) {
          }
          a += v
          if (v !== 0) {
            ac += 1
          }
        }
      }
      if (this.compare === '目標') {
        for (x = 0; x < 12; x++) {
          v = this.plans[item][x][metric.key].value
          p += v
          if (v !== 0) {
            pc += 1
          }
        }
      }
      if (this.compare !== 'N/A' && this.compare !== '目標') {
        for (x = 0; x < 12; x++) {
          v = this.diffs[item][x][index + 9].length
          d += v
          if (v !== 0) {
            dc += 1
          }
        }
      }
      if (type === 0) {
        if (metric.type === 'TTL') {
          var t = 0
          for (x = 0; x < 12; x++) {
            v = this.acts[item][x][17].length
            t += v
          }
          return t
        }
        if (this.compare !== 'N/A' && this.indicator === '%') {
          if (this.compare === '目標') {
            var r = Math.floor((a / ac) / (p / pc) * 100)
            return isNaN(r) || r === Infinity ? '0%' : r + '%'
          } else {
            r = Math.floor((a / ac) / (d / dc) * 100)
            return isNaN(r) || r === Infinity ? '0%' : r + '%'
          }
        } else {
          r = Math.floor(a / ac)
          return isNaN(r) || r === Infinity ? 0 : r
        }
      } else {
        if (this.compare === '目標') {
          r = Math.floor((p / pc))
          return isNaN(r) || r === Infinity ? 0 : r
        } else {
          r = Math.floor((d / dc))
          return isNaN(r) || r === Infinity ? 0 : r
        }
      }
    },
    getValue (item, month, index, type, metric) {
      var value = 0
      if (!this.status[item]) {
        return value
      }
      if (type === 0) {
        if (metric.type === 'TTL') {
          return this.acts[item][month - 1][17].length
        }
        if (this.compare !== 'N/A') {
          if (this.indicator === '%') {
            var p = Math.floor(this.status[item][month - 1][index + 9].length / this.plans[item][month - 1][metric.key].value * 10) / 10
            return isNaN(p) || p === Infinity ? '0%' : Math.round(p * 100) + '%'
          } else {
            return this.status[item][month - 1][index + 9].length
          }
        } else {
          return this.status[item][month - 1][index + 9].length
        }
      } else {
        if (this.compare === '目標') {
          return this.plans[item][month - 1][metric.key].value
        } else {
          return this.diffs[item][month - 1][index + 9].length
        }
      }
    },
    getTotalTyg (item, index, metric) {
      if (!this.acts[item]) {
        return 0
      }
      if (metric.type === 'TTL') {
        var d = 0
        for (var x = 0; x < 12; x++) {
          var v = this.acts[item][x][17].length
          d += v
        }
        return d
      } else {
        return this.totalTygs[item][index]
      }
    },
    getTyg (item, month, index, type, metric) {
      var value = 0
      if (!this.acts[item]) {
        return value
      }
      if (metric.type === 'TTL') {
        value = this.acts[item][month - 1][17].length
      } else {
        value = this.acts[item][month - 1][18 + index].length
      }
      return value
    },
    getName (item) {
      if (item === '*') {
        return '全校'
      }
      var index = this.groups.findIndex(group => group.key === item)
      if (index !== -1) {
        return this.groups[index].name
      }
      return ''
    },
    onDismissed: function (result) {
      this.dialog = false
      this.listDialog = false
      if (result) {
        this.$nextTick(function () {
          this.onUpdate()
        })
      }
    },
    onUpdate () {
    },
    onValueSelect (item, month, type, metric) {
      if (metric.type === 'TTL') {
        return
      }
      var index = this.headers.findIndex(head => head.key === metric.key)
      if (this.status[item][month - 1][index + 9].length !== 0) {
        this.selected = this.status[item][month - 1][index + 9]
        this.listDialog = true
      }
    },
    onTygSelect (item, month, type, metric) {
      var index = this.ycsheaders.findIndex(head => head.key === metric.key)
      if (month === 13) {
        if (this.totalTygs[item][index].length !== 0) {
          this.selected = this.totalTygs[item][index]
          this.listDialog = true
        }
      } else if (this.acts[item][month - 1][18 + index].length !== 0) {
        this.selected = this.acts[item][month - 1][18 + index]
        this.listDialog = true
      }
    }
  }
}
</script>

<style scoped>
input[type="file"] {
  display: none;
}
span.clickable {
  cursor: pointer !important;
}
.select-none {
  user-select: none;
}
.b-B-TITLE {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-R {
  border-right: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-L {
  border-left: 1px solid white !important;
  border-left-width: 1px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-T {
  border-top: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B {
  border-bottom: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-R-GREY {
  border-right: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-L-GREY {
  border-left: 1px solid #80808080 !important;
  border-left-width: 1px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-T-GREY {
  border-top: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B-GREY {
  border-bottom: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
